<template>
  <section v-if="data" class="relative h-full pb-4 overflow-x-auto bg-white">
    <table class="w-full text-sm text-left text-gray-900 divide-y divide-gray-200">
      <tbody>
        <BaseDetailsTableRow
          :name="$t('baseObject.name')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.name"
            color="base"
            flat
            :disabled="mode == 'view'"
            show-error-as-tooltip
            :error="
              validations?.name.required.$invalid ? validations.name.required.$message : ''
            " />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.code')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.code"
            color="base"
            flat
            :disabled="mode == 'view'"
            :error="validations?.code.required.$invalid ? validations.code.required.$message : ''"
            show-error-as-tooltip />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.title')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.title"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.job')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput :mode="mode" v-model="data.job" color="base" flat :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('taxNumber')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.taxNumber"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.doy')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput :mode="mode" v-model="data.doy" color="base" flat :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.county')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.county"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('city')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.city"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('address')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.address"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('zipCodes')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.zipCode"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('auth.email')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.email"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('telephone') + ' 1'"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.telephone1"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('telephone') + ' 2'"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.telephone2"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('competitor.remarks')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.remarks"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.firstName')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.firstName"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.lastName')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.lastName"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.socialNumber')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.socialNumberId"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.passport')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput
            :mode="mode"
            v-model="data.passportId"
            color="base"
            flat
            :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('trader.passportExpireDate')"
          :isHorizontalLayout="isHorizontalLayout">
          <div v-if="mode == 'view'">
            {{ isoDateToFullDate(data.passportExpiredDate) || '-' }}
          </div>
          <DateTimePicker
            v-else
            ref="passportExpireDatePickerRef"
            v-model="selectedPassportExpireDate"
            start-empty
            :show-time-picker="false"
            show-error-as-tooltip
            @update:modelValue="onDateChange($event, 'passport')">
          </DateTimePicker>
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.adt')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseInput :mode="mode" v-model="data.adt" color="base" flat :disabled="mode == 'view'" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :mode="mode"
          :name="$t('trader.adtDate')"
          :isHorizontalLayout="isHorizontalLayout">
          <div v-if="mode == 'view'">
            {{ isoDateToFullDate(data.adT_date) || '-' }}
          </div>
          <DateTimePicker
            v-else
            ref="adtDatePickerRef"
            v-model="selectedAdtDate"
            :show-time-picker="false"
            start-empty
            show-error-as-tooltip
            @update:modelValue="onDateChange($event, 'adt')">
          </DateTimePicker>
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.country')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseSelectDropdown
            :items="dropdownMWCountries"
            :selected-item="selectedCountry"
            name="paymentTypes"
            flat
            :mode="mode"
            @update:selected="handleCountrySelection"
            clearable
            show-error-as-tooltip
            :error="
              validations?.mwCountry.$invalid ? validations.mwCountry.required.$message : ''
            " />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('groups.accountGroup')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseSelectDropdown
            :items="dropdownMwAccountGroups"
            :selected-item="selectedAccountGroup"
            name="paymentTypes"
            flat
            :mode="mode"
            clearable
            @update:selected="handleAccountGroupSelection"
            show-error-as-tooltip
            :error="
              validations?.mwAccountGroup.$invalid
                ? validations.mwAccountGroup.required.$message
                : ''
            " />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('trader.taxOffice')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseSelectDropdown
            :items="dropDownTaxOffices"
            :selected-item="selectedTaxOffice"
            name="paymentTypes"
            flat
            clearable
            :mode="mode"
            @update:selected="handleTaxOfficeSelection" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.isActive')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellStatus v-if="mode == 'view'" :item="data.isActive ? data.isActive : 0" />
          <BaseToggle v-else label="Active" name="isActive" v-model="data.isActive" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.isFromManager')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          <BaseTableCellCheck :item="data.isFromManager ? data.isFromManager : false" />
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.lastUpdate')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ isoDateToFullDate(data.lastUpdate) || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.updateUser')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ data.updateUser?.name || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.createdDate')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ isoDateToFullDate(data.createdDate) || '-' }}
        </BaseDetailsTableRow>

        <BaseDetailsTableRow
          :name="$t('baseObject.createUser')"
          :mode="mode"
          :isHorizontalLayout="isHorizontalLayout">
          {{ data.createUser?.name || '-' }}
        </BaseDetailsTableRow>
      </tbody>
    </table>
  </section>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useLookupsStore } from '@/stores/lookups';
import {
  isoDateToFullDate,
  datepickerToServerDateFormat,
  isoDateToDatepickerFormat,
} from '@/utils/date';

import BaseDetailsTableRow from '../common/BaseDetailsTableRow.vue';
import BaseInput from '../common/BaseInput.vue';
import DateTimePicker from '../common/DateTimePicker.vue';
import BaseSelectDropdown from '../common/BaseSelectDropdown.vue';
import BaseToggle from '../common/BaseToggle.vue';
import BaseTableCellCheck from '../common/BaseTableCellCheck.vue';
import BaseTableCellStatus from '../common/BaseTableCellStatus.vue';

import type { Trader } from '@/types/Traders';
import type { SelectDropdownItem } from '@/types/Base';
import type { Validation } from '@vuelidate/core';

defineProps<{
  mode: 'view' | 'edit';
  isHorizontalLayout: boolean;
  validations?: Validation;
}>();

const { dropdownMWCountries, dropdownMwAccountGroups, dropDownTaxOffices, users } =
  storeToRefs(useLookupsStore());

const data = defineModel<Trader>();
const selectedPassportExpireDate = ref<string>('');
const selectedAdtDate = ref<string>('');
const selectedCountry = ref<SelectDropdownItem | null>(null);
const selectedAccountGroup = ref<SelectDropdownItem | null>(null);
const selectedTaxOffice = ref<SelectDropdownItem | null>(null);
const passportExpireDatePickerRef = ref();
const adtDatePickerRef = ref();

function initDropdowns() {
  if (!data.value) return;

  if (data.value.mwCountry) {
    const selectCountry = dropdownMWCountries.value.find(
      (item) => item.value == data.value?.mwCountryId
    );
    if (selectCountry) selectedCountry.value = selectCountry;
  }

  if (data.value.mwAccountGroupId) {
    const selectedAccount = dropdownMwAccountGroups.value.find(
      (item) => item.value == data.value?.mwAccountGroupId
    );
    if (selectedAccount) selectedAccountGroup.value = selectedAccount;
  }

  if (data.value.taxOfficeId) {
    const selectTax = dropDownTaxOffices.value.find(
      (item) => item.value == data.value?.taxOfficeId
    );
    if (selectTax) selectedTaxOffice.value = selectTax;
  }
}

function initProperties() {
  if (!data.value) return;
  if (data.value?.adT_date) {
    selectedAdtDate.value = isoDateToDatepickerFormat(data.value.adT_date);
  }
  if (data.value.passportExpiredDate) {
    selectedPassportExpireDate.value = isoDateToDatepickerFormat(data.value.passportExpiredDate);
  }
}

function populateUsersFromLookups() {
  if (data.value?.createUserId) {
    data.value.createUser = users.value.find((x) => x.id == data.value?.createUserId);
  }

  if (data.value?.updateUserId) {
    data.value.updateUser = users.value.find((x) => x.id == data.value?.updateUserId);
  }
}

onMounted(() => {
  initDropdowns();
  initProperties();
  populateUsersFromLookups();
});

function onDateChange(e: string | undefined, dateType: 'passport' | 'adt') {
  if (!data.value) return;
  if (dateType == 'passport') {
    data.value.passportExpiredDate = datepickerToServerDateFormat(selectedPassportExpireDate.value);
  } else {
    data.value.adT_date = datepickerToServerDateFormat(selectedAdtDate.value);
  }
}

function handleCountrySelection(item: SelectDropdownItem) {
  selectedCountry.value = item ? item : null;
  if (data.value) data.value.mwCountryId = item ? (item.value as string) : undefined;
}

function handleAccountGroupSelection(item: SelectDropdownItem) {
  selectedAccountGroup.value = item ? item : null;
  if (data.value) data.value.mwAccountGroupId = item ? (item.value as string) : undefined;
}

function handleTaxOfficeSelection(item: SelectDropdownItem) {
  selectedTaxOffice.value = item ? item : null;
  if (data.value) data.value.taxOfficeId = item ? (item.value as string) : undefined;
}
</script>
